import { render, staticRenderFns } from "./PersonalName.vue?vue&type=template&id=8922199a&scoped=true&lang=html"
import script from "./PersonalName.vue?vue&type=script&lang=ts"
export * from "./PersonalName.vue?vue&type=script&lang=ts"
import style0 from "./PersonalName.vue?vue&type=style&index=0&id=8922199a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8922199a",
  null
  
)

export default component.exports